export default __webpack_public_path__ + "static/media/Varsun_Services.621a6a6f.png";